const AUTH_FAILURE = 'AUTH_FAILURE';

const GET_ME_REQUEST = 'GET_ME_REQUEST';
const GET_ME_SUCCESS = 'GET_ME_SUCCESS';
const GET_ME_FAILURE = 'GET_ME_FAILURE';

const GET_REPOSITORY_SUCCESS = 'GET_REPOSITORY_SUCCESS';
const GET_REPOSITORY_REQUEST = 'GET_REPOSITORY_REQUEST';
const GET_REPOSITORY_FAILURE = 'GET_REPOSITORY_FAILURE';

const UPDATE_REPOSITORY_WITH_FOLDERS = 'UPDATE_REPOSITORY_WITH_FOLDERS';

const GET_FOLDER_REQUEST = 'GET_FOLDER_REQUEST';
const GET_FOLDER_SUCCESS = 'GET_FOLDER_SUCCESS';
const GET_FOLDER_FAILURE = 'GET_FOLDER_FAILURE';

const EXPLORE_FOLDER_REQUEST = 'EXPLORE_FOLDER_REQUEST';
const EXPLORE_FOLDER_SUCCESS = 'EXPLORE_FOLDER_SUCCESS';

const CREATE_FOLDER_REQUEST = 'CREATE_FOLDER_REQUEST';
const CREATE_FOLDER_SUCCESS = 'CREATE_FOLDER_SUCCESS';
const CREATE_FOLDER_FAILURE = 'CREATE_FOLDER_FAILURE';

const GET_TARGET_FOLDERS_REQUEST = 'GET_TARGET_FOLDERS_REQUEST';
const GET_TARGET_FOLDERS_SUCCESS = 'GET_TARGET_FOLDERS_SUCCESS';
const GET_TARGET_FOLDERS_FAILURE = 'GET_TARGET_FOLDERS_FAILURE';

const EXPLORE_TARGET_FOLDERS_REQUEST = 'EXPLORE_TARGET_FOLDERS_REQUEST';
const EXPLORE_TARGET_FOLDERS_SUCCESS = 'EXPLORE_TARGET_FOLDERS_SUCCESS';
const EXPLORE_TARGET_FOLDERS_FAILURE = 'EXPLORE_TARGET_FOLDERS_FAILURE';

const GET_TARGET_FOLDER_REQUEST = 'GET_TARGET_FOLDER_REQUEST';
const GET_TARGET_FOLDER_SUCCESS = 'GET_TARGET_FOLDER_SUCCESS';
const GET_TARGET_FOLDER_FAILURE = 'GET_TARGET_FOLDER_FAILURE';

const SHOW_MODAL = 'SHOW_MODAL';
const HIDE_MODAL = 'HIDE_MODAL';

const CLONE_AUDIENCE_REQUEST = 'CLONE_AUDIENCE_REQUEST';
const CLONE_AUDIENCE_SUCCESS = 'CLONE_AUDIENCE_SUCCESS';
const CLONE_AUDIENCE_FAILURE = 'CLONE_AUDIENCE_FAILURE';

const DELETE_ITEM_REQUEST = 'DELETE_ITEM_REQUEST';
const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
const DELETE_ITEM_FAILURE = 'DELETE_ITEM_FAILURE';

const ADD_TOAST = 'ADD_TOAST';
const REMOVE_TOAST = 'REMOVE_TOAST';

const RENAME_ITEM_REQUEST = 'RENAME_ITEM_REQUEST';
const RENAME_ITEM_SUCCESS = 'RENAME_ITEM_SUCCESS';
const RENAME_ITEM_FAILURE = 'RENAME_ITEM_FAILURE';

const UPDATE_WITH_CREATED_FOLDER = 'UPDATE_WITH_CREATED_FOLDER';

const MOVE_ITEM_REQUEST = 'MOVE_ITEM_REQUEST';
const MOVE_ITEM_SUCCESS = 'MOVE_ITEM_SUCCESS';
const MOVE_ITEM_FAILURE = 'MOVE_ITEM_FAILURE';

const TOGGLE_ITEM_SELECTION_REQUEST = 'TOGGLE_ITEM_SELECTION_REQUEST';
const TOGGLE_ITEM_SELECTION_SUCCESS = 'TOGGLE_ITEM_SELECTION_SUCCESS';

const TOGGLE_ALL_ITEM_SELECTION_REQUEST = 'TOGGLE_ALL_ITEM_SELECTION_REQUEST';
const TOGGLE_ALL_ITEM_SELECTION_SUCCESS = 'TOGGLE_ALL_ITEM_SELECTION_SUCCESS';

const SHOW_CREATE_AUDIENCE_MODAL = 'SHOW_CREATE_AUDIENCE_MODAL';
const SHOW_EDIT_AUDIENCE_MODAL = 'SHOW_EDIT_AUDIENCE_MODAL';
const HIDE_CREATE_AUDIENCE_MODAL = 'HIDE_CREATE_AUDIENCE_MODAL';
const SHOW_CREATE_TSV_MODAL = 'SHOW_CREATE_TSV_MODAL';
const HIDE_CREATE_TSV_MODAL = 'HIDE_CREATE_TSV_MODAL';

const CREATE_TSV_SUCCESS = 'CREATE_TSV_SUCCESS';
const CREATE_TSV_REQUEST = 'CREATE_TSV_REQUEST';
const CREATE_TSV_FAILURE = 'CREATE_TSV_FAILURE';

const TSV_STATUS_SUCCESS = 'TSV_STATUS_SUCCESS';
const TSV_STATUS_REQUEST = 'TSV_STATUS_REQUEST';
const TSV_STATUS_FAILURE = 'TSV_STATUS_FAILURE';

const UPDATE_QUERY = 'UPDATE_QUERY';

const ADD_QUERY_ENTITY_REQUEST = 'ADD_QUERY_ENTITY_REQUEST';
const ADD_QUERY_ENTITY_SUCCESS = 'ADD_QUERY_ENTITY_SUCCESS';

const REMOVE_QUERY_ENTITY_REQUEST = 'REMOVE_QUERY_ENTITY_REQUEST';

const UPDATE_QUERY_ENTITY_INFOS = 'UPDATE_QUERY_ENTITY_INFOS';

const CHANGE_QUERY_GROUP_OPERATOR_REQUEST =
  'CHANGE_QUERY_GROUP_OPERATOR_REQUEST';

const CHANGE_QUERY_GROUP_AT_LEAST_NUMBER_REQUEST =
  'CHANGE_QUERY_GROUP_AT_LEAST_NUMBER_REQUEST';

const CLEAR_QUERY_REQUEST = 'CLEAR_QUERY_REQUEST';
const GET_TAXONOMY_LIST_REQUEST = 'GET_TAXONOMY_LIST_REQUEST';
const GET_TAXONOMY_LIST_SUCCESS = 'GET_TAXONOMY_LIST_SUCCESS';
const GET_TAXONOMY_LIST_FAILURE = 'GET_TAXONOMY_LIST_FAILURE';
const GET_BASE_TAXONOMY = 'GET_BASE_TAXONOMY';
const GET_BASE_TAXONOMY_WITH_LIFESTYLES = 'GET_BASE_TAXONOMY_WITH_LIFESTYLES';

const GET_DEMOGRAPHICS_REQUEST = 'GET_DEMOGRAPHICS_REQUEST';
const GET_DEMOGRAPHICS_SUCCESS = 'GET_DEMOGRAPHICS_SUCCESS';
const GET_DEMOGRAPHICS_FAILURE = 'GET_DEMOGRAPHICS_FAILURE';

const GET_EXPLORE_ITEMS_REQUEST = 'GET_EXPLORE_ITEMS_REQUEST';
const GET_EXPLORE_ITEMS_SUCCESS = 'GET_EXPLORE_ITEMS_SUCCESS';
const GET_EXPLORE_ITEMS_FAILURE = 'GET_EXPLORE_ITEMS_FAILURE';

const LOAD_MORE_RESULTS_REQUEST = 'LOAD_MORE_RESULTS_REQUEST';
const LOAD_MORE_RESULTS_SUCCESS = 'LOAD_MORE_RESULTS_SUCCESS';
const LOAD_MORE_RESULTS_FAILURE = 'LOAD_MORE_RESULTS_FAILURE';

const MOVE_ENTITY_REQUEST = 'MOVE_ENTITY_REQUEST';
const GET_TIMEFRAMES_REQUEST = 'GET_TIMEFRAMES_REQUEST';
const GET_TIMEFRAMES_SUCCESS = 'GET_TIMEFRAMES_SUCCESS';

const CHANGE_AUDIENCE_TIMEFRAME_REQUEST = 'CHANGE_AUDIENCE_TIMEFRAME_REQUEST';
const CHANGE_RESULT_TIMEFRAME_REQUEST = 'CHANGE_RESULT_TIMEFRAME_REQUEST';

const GET_AUDIENCE_REQUEST = 'GET_AUDIENCE_REQUEST';
const GET_AUDIENCE_SUCCESS = 'GET_AUDIENCE_SUCCESS';
const GET_AUDIENCE_FAILURE = 'GET_AUDIENCE_FAILURE';

const CREATE_AUDIENCE_REQUEST = 'CREATE_AUDIENCE_REQUEST';
const CREATE_AUDIENCE_SUCCESS = 'CREATE_AUDIENCE_SUCCESS';
const CREATE_AUDIENCE_FAILURE = 'CREATE_AUDIENCE_FAILURE';

const GET_REPORT_ERROR_REQUEST = 'GET_REPORT_ERROR_REQUEST';
const GET_REPORT_ERROR_SUCCESS = 'GET_REPORT_ERROR_SUCCESS';
const GET_REPORT_ERROR_FAILURE = 'GET_REPORT_ERROR_FAILURE';

const QUERY_PREVIEW_REQUEST = 'QUERY_PREVIEW_REQUEST';

const GET_QUERY_PREVIEW_REQUEST = 'GET_QUERY_PREVIEW_REQUEST';
const GET_QUERY_PREVIEW_SUCCESS = 'GET_QUERY_PREVIEW_SUCCESS';
const GET_QUERY_PREVIEW_FAILURE = 'GET_QUERY_PREVIEW_FAILURE';

const ADD_QUERY_ITEM_WITH_INFOS_REQUEST = 'ADD_QUERY_ITEM_WITH_INFOS_REQUEST';
const ADD_ITEM_WITH_INFOS_IN_SELECTED_GROUP_REQUEST =
  'ADD_ITEM_WITH_INFOS_IN_SELECTED_GROUP_REQUEST';
const ADD_BLOCK_IN_SELECTED_GROUP_REQUEST =
  'ADD_BLOCK_IN_SELECTED_GROUP_REQUEST';

const ITEM_DRAG_TOGGLE = 'ITEM_DRAG_TOGGLE';
const ITEM_DRAG_DROP = 'ITEM_DRAG_DROP';

const SAVE_AUDIENCE_REQUEST = 'SAVE_AUDIENCE_REQUEST';
const SAVE_AUDIENCE_SUCCESS = 'SAVE_AUDIENCE_SUCCESS';
const SAVE_AUDIENCE_FAILURE = 'SAVE_AUDIENCE_FAILURE';

const ADD_APPLICATION_TAB = 'ADD_APPLICATION_TAB';
const CHANGE_SELECTED_APPLICATION_TAB = 'CHANGE_SELECTED_APPLICATION_TAB';
const REMOVE_APPLICATION_TAB = 'REMOVE_APPLICATION_TAB';
const UPDATE_TABS = 'UPDATE_TABS';
const ADD_EMPTY_TAB = 'ADD_EMPTY_TAB';
const UPDATE_APPLICATION_TAB = 'UPDATE_APPLICATION_TAB';

const UPDATE_TAB_LOADING_STATUS = 'UPDATE_TAB_LOADING_STATUS';
const UPDATE_TAB_LOADING_STATUS_SUCCESS = 'UPDATE_TAB_LOADING_STATUS_SUCCESS';

const CHANGE_BASE_QUERY_REQUEST = 'CHANGE_BASE_QUERY_REQUEST';
const CHANGE_BASE_QUERY_SUCCESS = 'CHANGE_BASE_QUERY_SUCCESS';

const REQUIRE_MISSING_ITEM_REQUEST = 'REQUIRE_MISSING_ITEM_REQUEST';
const REQUIRE_MISSING_ITEM_SUCCESS = 'REQUIRE_MISSING_ITEM_SUCCESS';
const REQUIRE_MISSING_ITEM_FAILURE = 'REQUIRE_MISSING_ITEM_FAILURE';

const RESET_QUERY_ERROR = 'RESET_QUERY_ERROR';

const REPOSITORY_LOAD_MORE_RESULTS_REQUEST =
  'REPOSITORY_LOAD_MORE_RESULTS_REQUEST';
const REPOSITORY_LOAD_MORE_RESULTS_SUCCESS =
  'REPOSITORY_LOAD_MORE_RESULTS_SUCCESS';
const REPOSITORY_LOAD_MORE_RESULTS_FAILURE =
  'REPOSITORY_LOAD_MORE_RESULTS_FAILURE';

const CHANGE_QUERY_TYPE_REQUEST = 'CHANGE_QUERY_TYPE_REQUEST';

const CHANGE_QUERY_BUILDER_TYPE_REQUEST = 'CHANGE_QUERY_BUILDER_TYPE_REQUEST';

const GET_ME_PRODUCTS_REQUEST = 'GET_ME_PRODUCTS_REQUEST';
const GET_ME_PRODUCTS_SUCCESS = 'GET_ME_PRODUCTS_SUCCESS';
const GET_ME_PRODUCTS_FAILURE = 'GET_ME_PRODUCTS_FAILURE';

const ADD_CONVERSATION_QUERY_REQUEST = 'ADD_CONVERSATION_QUERY_REQUEST';
const UPDATE_CONVERSATION_QUERY_REQUEST = 'UPDATE_CONVERSATION_QUERY_REQUEST';
const ADD_CONVERSATION_ITEM_IN_SELECTED_GROUP_REQUEST =
  'ADD_CONVERSATION_ITEM_IN_SELECTED_GROUP_REQUEST';
const DELETE_CONVERSATION_QUERY_REQUEST = 'DELETE_CONVERSATION_QUERY_REQUEST';
const ADD_CONVERSATION_ITEM_REQUEST = 'ADD_CONVERSATION_ITEM_REQUEST';
const MOVE_CONVERSATION_ITEM_REQUEST = 'MOVE_CONVERSATION_ITEM_REQUEST';
const CLEAR_CONVERSATION_QUERY_REQUEST = 'CLEAR_CONVERSATION_QUERY_REQUEST';
const EXPAND_REPOSITORY = 'EXPAND_REPOSITORY';
const COLLAPSE_REPOSITORY = 'COLLAPSE_REPOSITORY';
const FULL_VIEW_REPOSITORY = 'FULL_VIEW_REPOSITORY';

const CHECK_DATA_CONVERSATION_REQUEST = 'CHECK_DATA_CONVERSATION_REQUEST';
const CHECK_DATA_CONVERSATION_SUCCESS = 'CHECK_DATA_CONVERSATION_SUCCESS';
const CHECK_DATA_CONVERSATION_FAILURE = 'CHECK_DATA_CONVERSATION_FAILURE';
const RESET_CONVERSATION_QUERY_ERROR = 'RESET_CONVERSATION_QUERY_ERROR';

const GET_CONVERSATIONS_RECENT_REQUEST = 'GET_CONVERSATIONS_RECENT_REQUEST';
const GET_CONVERSATIONS_RECENT_SUCCESS = 'GET_CONVERSATIONS_RECENT_SUCCESS';
const GET_CONVERSATIONS_RECENT_FAILURE = 'GET_CONVERSATIONS_RECENT_FAILURE';

const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS';
const CREATE_CONVERSATION_REQUEST = 'CREATE_CONVERSATION_REQUEST';
const CREATE_CONVERSATION_FAILURE = 'CREATE_CONVERSATION_FAILURE';

const CONVERSATION_STATUS_SUCCESS = 'CONVERSATION_STATUS_SUCCESS';
const CONVERSATION_STATUS_REQUEST = 'CONVERSATION_STATUS_REQUEST';
const CONVERSATION_STATUS_FAILURE = 'CONVERSATION_STATUS_FAILURE';

const GET_EXPLORE_CONVERSATION_ITEMS_REQUEST =
  'GET_EXPLORE_CONVERSATION_ITEMS_REQUEST';
const GET_EXPLORE_CONVERSATION_ITEMS_SUCCESS =
  'GET_EXPLORE_CONVERSATION_ITEMS_SUCCESS';
const GET_EXPLORE_CONVERSATION_ITEMS_FAILURE =
  'GET_EXPLORE_CONVERSATION_ITEMS_FAILURE';

const OPEN_SAVE_MODAL = 'OPEN_SAVE_MODAL';

const HIDE_REPOSITORY = 'HIDE_REPOSITORY';
const SHOW_REPOSITORY = 'SHOW_REPOSITORY';

const GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST =
  'GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST';
const GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS =
  'GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS';
const GET_DEMOGRAPHICS_SEARCH_RESULTS_FAILURE =
  'GET_DEMOGRAPHICS_SEARCH_RESULTS_FAILURE';

const CREATE_SUPPORT_TICKET_REQUEST = 'CREATE_SUPPORT_TICKET_REQUEST';
const CREATE_SUPPORT_TICKET_SUCCESS = 'CREATE_SUPPORT_TICKET_SUCCESS';
const CREATE_SUPPORT_TICKET_FAILURE = 'CREATE_SUPPORT_TICKET_FAILURE';

const GET_FUSIONS_REQUEST = 'GET_FUSIONS_REQUEST';
const GET_FUSIONS_SUCCESS = 'GET_FUSIONS_SUCCESS';
const GET_FUSIONS_FAILURE = 'GET_FUSIONS_FAILURE';

const GET_AUDIENCE_BUILDERS_REQUEST = 'GET_AUDIENCE_BUILDERS_REQUEST';
const GET_AUDIENCE_BUILDERS_SUCCESS = 'GET_AUDIENCE_BUILDERS_SUCCESS';
const GET_AUDIENCE_BUILDERS_FAILURE = 'GET_AUDIENCE_BUILDERS_FAILURE';

const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';

const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

const GET_USERS_BY_COMPANY_REQUEST = 'GET_USERS_BY_COMPANY_REQUEST';
const GET_USERS_BY_COMPANY_SUCCESS = 'GET_USERS_BY_COMPANY_SUCCESS';
const GET_USERS_BY_COMPANY_FAILURE = 'GET_USERS_BY_COMPANY_FAILURE';

const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';
const RECEIVED_NOTIFICATION = 'RECEIVED_NOTIFICATION';

const SHARE_AUDIENCE_REQUEST = 'SHARE_AUDIENCE_REQUEST';
const SHARE_AUDIENCE_SUCCESS = 'SHARE_AUDIENCE_SUCCESS';
const SHARE_AUDIENCE_FAILURE = 'SHARE_AUDIENCE_FAILURE';

const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';
const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
const DELETE_NOTIFICATION_FAILURE = 'DELETE_NOTIFICATION_FAILURE';

const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
const MARK_NOTIFICATION_AS_READ_FAILURE = 'MARK_NOTIFICATION_AS_READ_FAILURE';

const MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST =
  'MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST';
const MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS =
  'MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS';
const MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE =
  'MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE';

const OPEN_AUDIENCE_REQUEST = 'OPEN_AUDIENCE_REQUEST';
const OPEN_AUDIENCE_SUCCESS = 'OPEN_AUDIENCE_SUCCESS';
const OPEN_AUDIENCE_FAILURE = 'OPEN_AUDIENCE_FAILURE';

const SEND_WEBSOCKET_MESSAGE = 'SEND_WEBSOCKET_MESSAGE';
const STORE_WEBSOCKET_CONTAINER = 'STORE_WEBSOCKET_CONTAINER';

const INITIALIZE_QUERY_BUILDER = 'INITIALIZE_QUERY_BUILDER';
const CHANGE_TARGET_COLOR = 'CHANGE_TARGET_COLOR';
const CHANGE_TARGET_TITLE = 'CHANGE_TARGET_TITLE';
const CHANGE_TARGET_SELECTED = 'CHANGE_TARGET_SELECTED';
const ADD_NEW_TARGET = 'ADD_NEW_TARGET';
const REMOVE_TARGET = 'REMOVE_TARGET';
const UPDATE_TARGETS = 'UPDATE_TARGETS';
const CLEAR_ALL_QUERIES_REQUEST = 'CLEAR_ALL_QUERIES_REQUEST';

const ADD_APPLICATION_DROPPING_ENTITY_REQUEST =
  'ADD_APPLICATION_DROPPING_ENTITY_REQUEST';
const UPDATE_APPLICATION_DROPPING_ENTITIES_REQUEST =
  'UPDATE_APPLICATION_DROPPING_ENTITIES_REQUEST';
const REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST =
  'REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST';
const REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST =
  'REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST';
const SHOW_COMPARE_AUDIENCE_MODAL = 'SHOW_COMPARE_AUDIENCE_MODAL';
const ADD_AUDIENCE_TO_COMPARE_REQUEST = 'ADD_AUDIENCE_TO_COMPARE_REQUEST';
const ADD_AUDIENCE_TO_COMPARE_SUCCESS = 'ADD_AUDIENCE_TO_COMPARE_SUCCESS';
const ADD_AUDIENCE_TO_COMPARE_FAILURE = 'ADD_AUDIENCE_TO_COMPARE_FAILURE';
const OPEN_COMPARE_AFTER_SAVE = 'OPEN_COMPARE_AFTER_SAVE';
const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
const SET_ERROR = 'SET_ERROR';

const SEND_EVENT_REQUEST = 'SEND_EVENT_REQUEST';
const SEND_EVENT_SUCCESS = 'SEND_EVENT_SUCCESS';

const SEND_STATE_CHANGE_EVENT = 'SEND_STATE_CHANGE_EVENT';
const SEND_STATE_CHANGE_SUCCESS = 'SEND_STATE_CHANGE_SUCCESS';

const GET_QUERY_MEMBERSHIP_REQUEST = 'GET_QUERY_MEMBERSHIP_REQUEST';
const GET_QUERY_MEMBERSHIP_SUCCESS = 'GET_QUERY_MEMBERSHIP_SUCCESS';
const GET_QUERY_MEMBERSHIP_FAILURE = 'GET_QUERY_MEMBERSHIP_FAILURE';

const COPY_TARGET = 'COPY_TARGET';
const REPLACE_TARGET_QUERY_REQUEST = 'REPLACE_TARGET_QUERY_REQUEST';
const MERGE_TARGET_QUERY_REQUEST = 'MERGE_TARGET_QUERY_REQUEST';
const SELECT_QUERY_GROUP_REQUEST = 'SELECT_QUERY_GROUP_REQUEST';

const GET_ALL_FOLDERS_REQUEST = 'GET_ALL_FOLDERS_REQUEST';
const GET_ALL_FOLDERS_SUCCESS = 'GET_ALL_FOLDERS_SUCCESS';
const GET_ALL_FOLDERS_FAILURE = 'GET_ALL_FOLDERS_FAILURE';

const GET_SAVED_QUERIES_REQUEST = 'GET_SAVED_QUERIES_REQUEST';
const GET_SAVED_QUERIES_SUCCESS = 'GET_SAVED_QUERIES_SUCCESS';
const GET_SAVED_QUERIES_FAILURE = 'GET_SAVED_QUERIES_FAILURE';

const LOAD_MORE_SAVED_QUERIES_REQUEST = 'LOAD_MORE_SAVED_QUERIES_REQUEST';
const LOAD_MORE_SAVED_QUERIES_SUCCESS = 'LOAD_MORE_SAVED_QUERIES_SUCCESS';
const LOAD_MORE_SAVED_QUERIES_FAILURE = 'LOAD_MORE_SAVED_QUERIES_FAILURE';

const ADD_ITEM_TO_COMPARE = 'ADD_ITEM_TO_COMPARE';
const REMOVE_ITEM_TO_COMPARE = 'REMOVE_ITEM_TO_COMPARE';
const REMOVE_ALL_ITEMS_TO_COMPARE = 'REMOVE_ALL_ITEMS_TO_COMPARE';
const RESET_COMPARE_ERROR = 'RESET_COMPARE_ERROR';
const SET_COMPARE_ERROR = 'SET_COMPARE_ERROR';

const ADD_SELECTED_AUDIENCES = 'ADD_SELECTED_AUDIENCES';
const REMOVE_SELECTED_AUDIENCE = 'REMOVE_SELECTED_AUDIENCE';
const REMOVE_ALL_SELECTED_AUDIENCES = 'REMOVE_ALL_SELECTED_AUDIENCES';

const GET_MY_COMPANY_REQUEST = 'GET_MY_COMPANY_REQUEST';
const GET_MY_COMPANY_SUCCESS = 'GET_MY_COMPANY_SUCCESS';
const GET_MY_COMPANY_FAILURE = 'GET_MY_COMPANY_FALURE';

const IGNORE_TWITTER_TOKEN_REQUEST = 'IGNORE_TWITTER_TOKEN_REQUEST';
const IGNORE_TWITTER_TOKEN_SUCCESS = 'IGNORE_TWITTER_TOKEN_SUCCESS';
const IGNORE_TWITTER_TOKEN_FAILURE = 'IGNORE_TWITTER_TOKEN_FAILURE';

const GENERATE_TWITTER_URL_REQUEST = 'GENERATE_TWITTER_URL_REQUEST';
const GENERATE_TWITTER_URL_SUCCESS = 'GENERATE_TWITTER_URL_SUCCESS';
const GENERATE_TWITTER_URL_FAILURE = 'GENERATE_TWITTER_URL_FAILURE';

const CLOSE_TWITTER_AUTHORIZATION_MODAL = 'CLOSE_TWITTER_AUTHORIZATION_MODAL';
const TWITTER_CALLBACK_URL_STATUS_SUCCESS =
  'TWITTER_CALLBACK_URL_STATUS_SUCCESS';
const TWITTER_CALLBACK_URL_STATUS_FAILURE =
  'TWITTER_CALLBACK_URL_STATUS_FAILURE';
const REFRESH_ME = 'REFRESH_ME';

const CHANGE_DATA_SOURCE = 'CHANGE_DATA_SOURCE';
const CHANGE_DATA_SOURCE_REQUEST = 'CHANGE_DATA_SOURCE_REQUEST';

const UPDATE_TABS_FROM_COMPANY_SETTINGS = 'UPDATE_TABS_FROM_COMPANY_SETTINGS';

export {
  GET_ME_REQUEST,
  GET_ME_SUCCESS,
  GET_ME_FAILURE,
  GET_REPOSITORY_REQUEST,
  GET_REPOSITORY_SUCCESS,
  GET_REPOSITORY_FAILURE,
  UPDATE_REPOSITORY_WITH_FOLDERS,
  GET_FOLDER_REQUEST,
  GET_FOLDER_SUCCESS,
  GET_FOLDER_FAILURE,
  EXPLORE_FOLDER_REQUEST,
  EXPLORE_FOLDER_SUCCESS,
  CREATE_FOLDER_REQUEST,
  CREATE_FOLDER_SUCCESS,
  CREATE_FOLDER_FAILURE,
  SHOW_MODAL,
  HIDE_MODAL,
  GET_TARGET_FOLDERS_REQUEST,
  GET_TARGET_FOLDERS_SUCCESS,
  GET_TARGET_FOLDERS_FAILURE,
  EXPLORE_TARGET_FOLDERS_REQUEST,
  EXPLORE_TARGET_FOLDERS_SUCCESS,
  EXPLORE_TARGET_FOLDERS_FAILURE,
  GET_TARGET_FOLDER_REQUEST,
  GET_TARGET_FOLDER_SUCCESS,
  GET_TARGET_FOLDER_FAILURE,
  CLONE_AUDIENCE_REQUEST,
  CLONE_AUDIENCE_SUCCESS,
  CLONE_AUDIENCE_FAILURE,
  DELETE_ITEM_REQUEST,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAILURE,
  ADD_TOAST,
  REMOVE_TOAST,
  RENAME_ITEM_REQUEST,
  RENAME_ITEM_SUCCESS,
  RENAME_ITEM_FAILURE,
  UPDATE_WITH_CREATED_FOLDER,
  MOVE_ITEM_REQUEST,
  MOVE_ITEM_SUCCESS,
  MOVE_ITEM_FAILURE,
  TOGGLE_ITEM_SELECTION_REQUEST,
  TOGGLE_ITEM_SELECTION_SUCCESS,
  TOGGLE_ALL_ITEM_SELECTION_REQUEST,
  TOGGLE_ALL_ITEM_SELECTION_SUCCESS,
  SHOW_CREATE_AUDIENCE_MODAL,
  SHOW_EDIT_AUDIENCE_MODAL,
  HIDE_CREATE_AUDIENCE_MODAL,
  ADD_QUERY_ENTITY_REQUEST,
  ADD_QUERY_ENTITY_SUCCESS,
  REMOVE_QUERY_ENTITY_REQUEST,
  UPDATE_QUERY_ENTITY_INFOS,
  UPDATE_QUERY,
  CLEAR_QUERY_REQUEST,
  CHANGE_QUERY_GROUP_OPERATOR_REQUEST,
  GET_TAXONOMY_LIST_REQUEST,
  GET_TAXONOMY_LIST_SUCCESS,
  GET_TAXONOMY_LIST_FAILURE,
  GET_DEMOGRAPHICS_REQUEST,
  GET_DEMOGRAPHICS_SUCCESS,
  GET_DEMOGRAPHICS_FAILURE,
  GET_EXPLORE_ITEMS_REQUEST,
  GET_EXPLORE_ITEMS_SUCCESS,
  GET_EXPLORE_ITEMS_FAILURE,
  LOAD_MORE_RESULTS_REQUEST,
  LOAD_MORE_RESULTS_SUCCESS,
  LOAD_MORE_RESULTS_FAILURE,
  MOVE_ENTITY_REQUEST,
  GET_TIMEFRAMES_REQUEST,
  GET_TIMEFRAMES_SUCCESS,
  CHANGE_AUDIENCE_TIMEFRAME_REQUEST,
  CHANGE_RESULT_TIMEFRAME_REQUEST,
  GET_AUDIENCE_REQUEST,
  GET_AUDIENCE_SUCCESS,
  GET_AUDIENCE_FAILURE,
  CREATE_AUDIENCE_REQUEST,
  CREATE_AUDIENCE_SUCCESS,
  CREATE_AUDIENCE_FAILURE,
  GET_REPORT_ERROR_REQUEST,
  GET_REPORT_ERROR_SUCCESS,
  GET_REPORT_ERROR_FAILURE,
  QUERY_PREVIEW_REQUEST,
  GET_QUERY_PREVIEW_REQUEST,
  GET_QUERY_PREVIEW_SUCCESS,
  GET_QUERY_PREVIEW_FAILURE,
  ADD_QUERY_ITEM_WITH_INFOS_REQUEST,
  ITEM_DRAG_TOGGLE,
  ITEM_DRAG_DROP,
  SAVE_AUDIENCE_REQUEST,
  SAVE_AUDIENCE_SUCCESS,
  SAVE_AUDIENCE_FAILURE,
  AUTH_FAILURE,
  ADD_APPLICATION_TAB,
  CHANGE_SELECTED_APPLICATION_TAB,
  ADD_EMPTY_TAB,
  UPDATE_APPLICATION_TAB,
  REMOVE_APPLICATION_TAB,
  UPDATE_TABS,
  UPDATE_TAB_LOADING_STATUS,
  UPDATE_TAB_LOADING_STATUS_SUCCESS,
  CHANGE_BASE_QUERY_REQUEST,
  CHANGE_BASE_QUERY_SUCCESS,
  REQUIRE_MISSING_ITEM_REQUEST,
  REQUIRE_MISSING_ITEM_SUCCESS,
  REQUIRE_MISSING_ITEM_FAILURE,
  RESET_QUERY_ERROR,
  REPOSITORY_LOAD_MORE_RESULTS_REQUEST,
  REPOSITORY_LOAD_MORE_RESULTS_SUCCESS,
  REPOSITORY_LOAD_MORE_RESULTS_FAILURE,
  CHANGE_QUERY_TYPE_REQUEST,
  CHANGE_QUERY_BUILDER_TYPE_REQUEST,
  GET_ME_PRODUCTS_REQUEST,
  GET_ME_PRODUCTS_SUCCESS,
  GET_ME_PRODUCTS_FAILURE,
  ADD_CONVERSATION_QUERY_REQUEST,
  UPDATE_CONVERSATION_QUERY_REQUEST,
  DELETE_CONVERSATION_QUERY_REQUEST,
  ADD_CONVERSATION_ITEM_REQUEST,
  MOVE_CONVERSATION_ITEM_REQUEST,
  CLEAR_CONVERSATION_QUERY_REQUEST,
  EXPAND_REPOSITORY,
  COLLAPSE_REPOSITORY,
  FULL_VIEW_REPOSITORY,
  RESET_CONVERSATION_QUERY_ERROR,
  CHECK_DATA_CONVERSATION_REQUEST,
  CHECK_DATA_CONVERSATION_SUCCESS,
  CHECK_DATA_CONVERSATION_FAILURE,
  GET_CONVERSATIONS_RECENT_REQUEST,
  GET_CONVERSATIONS_RECENT_SUCCESS,
  GET_CONVERSATIONS_RECENT_FAILURE,
  CREATE_CONVERSATION_REQUEST,
  CREATE_CONVERSATION_SUCCESS,
  CREATE_CONVERSATION_FAILURE,
  CONVERSATION_STATUS_REQUEST,
  CONVERSATION_STATUS_SUCCESS,
  CONVERSATION_STATUS_FAILURE,
  OPEN_SAVE_MODAL,
  GET_EXPLORE_CONVERSATION_ITEMS_REQUEST,
  GET_EXPLORE_CONVERSATION_ITEMS_SUCCESS,
  GET_EXPLORE_CONVERSATION_ITEMS_FAILURE,
  HIDE_REPOSITORY,
  SHOW_REPOSITORY,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_FAILURE,
  SHOW_CREATE_TSV_MODAL,
  HIDE_CREATE_TSV_MODAL,
  CREATE_TSV_SUCCESS,
  CREATE_TSV_REQUEST,
  CREATE_TSV_FAILURE,
  TSV_STATUS_FAILURE,
  TSV_STATUS_SUCCESS,
  TSV_STATUS_REQUEST,
  CREATE_SUPPORT_TICKET_REQUEST,
  CREATE_SUPPORT_TICKET_SUCCESS,
  CREATE_SUPPORT_TICKET_FAILURE,
  GET_BASE_TAXONOMY,
  GET_BASE_TAXONOMY_WITH_LIFESTYLES,
  GET_FUSIONS_REQUEST,
  GET_FUSIONS_SUCCESS,
  GET_FUSIONS_FAILURE,
  GET_AUDIENCE_BUILDERS_REQUEST,
  GET_AUDIENCE_BUILDERS_SUCCESS,
  GET_AUDIENCE_BUILDERS_FAILURE,
  GET_COMPANIES_REQUEST,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_BY_COMPANY_REQUEST,
  GET_USERS_BY_COMPANY_SUCCESS,
  GET_USERS_BY_COMPANY_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  SHARE_AUDIENCE_REQUEST,
  SHARE_AUDIENCE_SUCCESS,
  SHARE_AUDIENCE_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  MARK_NOTIFICATION_AS_READ_FAILURE,
  MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_AS_READ_FAILURE,
  OPEN_AUDIENCE_REQUEST,
  OPEN_AUDIENCE_SUCCESS,
  OPEN_AUDIENCE_FAILURE,
  SEND_WEBSOCKET_MESSAGE,
  STORE_WEBSOCKET_CONTAINER,
  RECEIVED_NOTIFICATION,
  INITIALIZE_QUERY_BUILDER,
  CHANGE_TARGET_COLOR,
  CHANGE_TARGET_TITLE,
  ADD_NEW_TARGET,
  UPDATE_TARGETS,
  REMOVE_TARGET,
  CHANGE_TARGET_SELECTED,
  CLEAR_ALL_QUERIES_REQUEST,
  ADD_APPLICATION_DROPPING_ENTITY_REQUEST,
  UPDATE_APPLICATION_DROPPING_ENTITIES_REQUEST,
  REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST,
  REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST,
  SHOW_COMPARE_AUDIENCE_MODAL,
  ADD_AUDIENCE_TO_COMPARE_REQUEST,
  ADD_AUDIENCE_TO_COMPARE_SUCCESS,
  ADD_AUDIENCE_TO_COMPARE_FAILURE,
  OPEN_COMPARE_AFTER_SAVE,
  SET_LOADING_STATUS,
  SEND_EVENT_REQUEST,
  SEND_EVENT_SUCCESS,
  GET_QUERY_MEMBERSHIP_REQUEST,
  GET_QUERY_MEMBERSHIP_SUCCESS,
  GET_QUERY_MEMBERSHIP_FAILURE,
  COPY_TARGET,
  REPLACE_TARGET_QUERY_REQUEST,
  MERGE_TARGET_QUERY_REQUEST,
  ADD_ITEM_WITH_INFOS_IN_SELECTED_GROUP_REQUEST,
  SELECT_QUERY_GROUP_REQUEST,
  ADD_CONVERSATION_ITEM_IN_SELECTED_GROUP_REQUEST,
  CHANGE_QUERY_GROUP_AT_LEAST_NUMBER_REQUEST,
  SET_ERROR,
  SEND_STATE_CHANGE_EVENT,
  SEND_STATE_CHANGE_SUCCESS,
  GET_ALL_FOLDERS_REQUEST,
  GET_ALL_FOLDERS_SUCCESS,
  GET_ALL_FOLDERS_FAILURE,
  GET_SAVED_QUERIES_REQUEST,
  GET_SAVED_QUERIES_SUCCESS,
  GET_SAVED_QUERIES_FAILURE,
  LOAD_MORE_SAVED_QUERIES_REQUEST,
  LOAD_MORE_SAVED_QUERIES_SUCCESS,
  LOAD_MORE_SAVED_QUERIES_FAILURE,
  ADD_BLOCK_IN_SELECTED_GROUP_REQUEST,
  ADD_ITEM_TO_COMPARE,
  REMOVE_ITEM_TO_COMPARE,
  REMOVE_ALL_ITEMS_TO_COMPARE,
  RESET_COMPARE_ERROR,
  SET_COMPARE_ERROR,
  ADD_SELECTED_AUDIENCES,
  REMOVE_SELECTED_AUDIENCE,
  REMOVE_ALL_SELECTED_AUDIENCES,
  GET_MY_COMPANY_REQUEST,
  GET_MY_COMPANY_SUCCESS,
  GET_MY_COMPANY_FAILURE,
  IGNORE_TWITTER_TOKEN_REQUEST,
  IGNORE_TWITTER_TOKEN_SUCCESS,
  IGNORE_TWITTER_TOKEN_FAILURE,
  GENERATE_TWITTER_URL_REQUEST,
  GENERATE_TWITTER_URL_SUCCESS,
  GENERATE_TWITTER_URL_FAILURE,
  CLOSE_TWITTER_AUTHORIZATION_MODAL,
  REFRESH_ME,
  TWITTER_CALLBACK_URL_STATUS_SUCCESS,
  TWITTER_CALLBACK_URL_STATUS_FAILURE,
  CHANGE_DATA_SOURCE,
  CHANGE_DATA_SOURCE_REQUEST,
  UPDATE_TABS_FROM_COMPANY_SETTINGS,
};
